import React, { useContext } from "react";
import { UserContext } from "../Context/UserContext";

const withUserDetails = (WrappedComponent) => {
  return (props) => {
    const [
      getUserInfo,
      getUserPermissions,
      hasPermission,
      hasRecordPermission,
      hasAnyRecordPermission,
      logout,
    ] = useContext(UserContext);
    return (
      <WrappedComponent
        getUserInfo={getUserInfo}
        hasPermission={hasPermission}
        hasRecordPermission={hasRecordPermission}
        getUserPermissions={getUserPermissions}
        hasAnyRecordPermission={hasAnyRecordPermission}
        logout={logout}
        {...props}
      />
    );
  };
};

export default withUserDetails;
